export default {
    isChrome: () => /chrome/i.test(navigator.userAgent),
    isFirefox: () => /firefox/i.test(navigator.userAgent),
    // https://msdn.microsoft.com/en-us/library/ms537503(v=vs.85).aspx
    isIE: () => /msie/i.test(navigator.userAgent) || /trident/i.test(navigator.userAgent),
    isEdge: () => /edge/i.test(navigator.userAgent)
};
